import { replacePathParams } from '@/api/utils';

export const caseApiPaths = {
  list: '/caseservice/cases',
  count: '/caseservice/cases/count',
  duplicatesList: '/caseservice/cases/cases-duplicates',
  createDraftCase: '/caseservice/cases/create-draft',
  createTxCenterDraftCase: '/caseservice/cases/create-tx-center-draft',
  createClinicalScreeningCase: '/caseservice/cases/create-clinical-screening',
  deleteDraftCase: '/caseservice/cases/delete-draft/:caseId',
  caseById: '/caseservice/cases/:caseId',
  caseUpdate: '/caseservice/cases/:caseId',
  updateTxCenterOR: '/caseservice/cases/:caseId/recipient-hospital-or-data',
  caseStatus: '/caseservice/cases/:caseId/change-status',
  caseNotes: '/caseservice/cases/:caseId/notes',
  caseNoteById: '/caseservice/cases/:caseId/notes/:noteId',
  pinCaseNote: '/caseservice/cases/:caseId/notes/:noteId/pin',
  unpinCaseNote: '/caseservice/cases/:caseId/notes/:noteId/unpin',
  caseLogs: '/caseservice/cases/:caseId/logs',
  caseActivityLog: '/caseservice/cases/:caseId/activity-log',
  setSirensLightsSupport: '/caseservice/cases/:caseId/set-sirens-lights-support',
  setNonStopFlightRequired: '/caseservice/cases/:caseId/set-non-stop-flight-required',
  setKidneyTrial: '/caseservice/cases/:caseId/set-kidney-trial',
  setQuestionaryEditAllowance: '/caseservice/cases/:caseId/set-questionary-edit-allowance',
  archiveCases: '/caseservice/cases/archive',
  bulkAssignmentCases: '/caseservice/bulk/cases',
  bulkAssignmentStatus: '/caseservice/bulk/assignees/active',
  bulkAssignmentAction: '/caseservice/bulk/assignees',
  // reallocation
  reallocationCandidates: '/caseservice/cases/reallocation-candidates',
  createReallocationDraft: '/caseservice/cases/create-draft-reallocated',
  createReallocationClinicalScreening: '/caseservice/cases/create-clinical-screening-reallocated',
  updateReallocated: '/caseservice/cases/:caseId/reallocation',
  // organ acceptance criteria
  caseOrganAcceptanceCriteria: '/caseservice/cases/:caseId/organacceptancecriteria',
  getOrganAcceptanceCriteriaTemplate: '/caseservice/cases/organ-acceptance-criteria-template',
  createOrganAcceptanceCriteriaTemplate: '/caseservice/cases/create-organ-acceptance-criteria-default-template',
  updateOrganAcceptanceCriteriaTemplate:
    '/caseservice/cases/:templateId/update-organ-acceptance-criteria-default-template',
  // assignments
  assignUsers: '/caseservice/cases/:caseId/assignees',
  assignOpoContacts: '/caseservice/opocontacts/:caseId/assignees',
  // case status
  statusClinicalScreening: '/caseservice/cases/:caseId/status/clinical-screening',
  statusAccepted: '/caseservice/cases/:caseId/status/accepted',
  statusPendingLogistics: '/caseservice/cases/:caseId/status/pending-logistics',
  statusResourcesBooked: '/caseservice/cases/:caseId/status/resources-booked',
  statusResourcesDeployed: '/caseservice/cases/:caseId/status/resource-deployed',
  statusAtDonorHospital: '/caseservice/cases/:caseId/status/at-donor-hospital',
  statusOnOcs: '/caseservice/cases/:caseId/status/on-ocs',
  statusDeployedToTxCenter: '/caseservice/cases/:caseId/status/deployed-to-txcenter',
  statusAtTxCenter: '/caseservice/cases/:caseId/status/at-txcenter',
  statusOffOcs: '/caseservice/cases/:caseId/status/off-ocs',
  statusReturningToBase: '/caseservice/cases/:caseId/status/returning-to-base',
  statusCaseFinished: '/caseservice/cases/:caseId/status/case-finished',
  statusCaseClosed: '/caseservice/cases/:caseId/status/case-closed',
  statusCasesClosed: '/caseservice/cases/status/cases-closed',
  statusDeclined: '/caseservice/cases/:caseId/status/declined',
  statusServiceDeclined: '/caseservice/cases/:caseId/status/service-declined',
  statusRollbackToServiceDeclined: '/caseservice/cases/:caseId/status/back-to-service-declined',
  statusChange: '/caseservice/cases/:caseId/status/change',
  // route planning status
  routePlanningStatus: 'caseservice/cases/:caseId/status/route-planning',
  waitingAviationApproval: 'caseservice/cases/:caseId/route-planning/waiting-aviation-approval',
  approveAviation: 'caseservice/cases/:caseId/route-planning/approve-aviation',
  rejectAviation: 'caseservice/cases/:caseId/route-planning/reject-aviation',
  waitingForQuoteApproval: 'caseservice/cases/:caseId/route-planning/waiting-for-quote-approval',
  approveGround: 'caseservice/cases/:caseId/route-planning/approve-ground',
  approveQuoteInternally: 'caseservice/cases/:caseId/route-planning/approve-quote-internally',
  quoteSentToTxReview: 'caseservice/cases/:caseId/route-planning/quote-sent-to-tx-review',
  bookingPendingStatus: 'caseservice/cases/:caseId/route-planning/booking-pending',
  resourceBookedRouteStatus: 'caseservice/cases/:caseId/route-planning/resources-booked',
  routePlanningDoneStatus: 'caseservice/cases/:caseId/route-planning/route-planning-done',
  // quote approval
  approveQuoteByTx: '/caseservice/cases/:caseId/quote/approvebytxcenter',
  rejectQuoteByTx: '/caseservice/cases/:caseId/quote/rejectbytxcenter',
  // organ approval
  declineOrgan: '/caseservice/cases/:caseId/organ/decline',
  approveOrgan: '/caseservice/cases/:caseId/organ/approve',
  // service approval
  declineService: '/caseservice/cases/:caseId/service/rejectbytxcenter',
  approveService: '/caseservice/cases/:caseId/service/approvebytxcenter',

  favorite: '/caseservice/cases/:caseId/favorite',
  // links
  addLink: '/caseservice/cases/:caseId/links',
  changeLink: '/caseservice/cases/:caseId/links/:linkId',
  // clinical-data
  randomizationClinicalData: '/caseservice/cases/:caseId/clinical-data/randomization',
  kidneyRandomization: '/caseservice/cases/:caseId/clinical-data/kidney-randomization',
  copyClinicalData: '/caseservice/cases/clinical-data/copy-reallocation',
  changeSupplementalOrgan: 'caseservice/cases/:caseId/clinical-data/supplemental-organs',
  wols: '/caseservice/cases/:caseId/clinical-data/wols',
  nrpType: '/caseservice/cases/:caseId/clinical-data/nrp-applicability-and-type',
  // clinical specialist status
  csDeployedToDonorHospital:
    '/caseservice/cases/:caseId/resources/clinical-specialist/:employeeId/deployed-to-donor-hospital',
  csAtDonor: '/caseservice/cases/:caseId/resources/clinical-specialist/:employeeId/at-donor',
  csOnOcs: '/caseservice/cases/:caseId/resources/clinical-specialist/:employeeId/on-ocs',
  csDeployedFromDonorHospital:
    '/caseservice/cases/:caseId/resources/clinical-specialist/:employeeId/deployed-from-donor-hospital',
  csAtTxCenter: '/caseservice/cases/:caseId/resources/clinical-specialist/:employeeId/at-txcenter',
  csOffOcs: '/caseservice/cases/:caseId/resources/clinical-specialist/:employeeId/off-ocs',
  csDeployedFromTxCenter: '/caseservice/cases/:caseId/resources/clinical-specialist/:employeeId/deployed-from-txcenter',
  csDone: '/caseservice/cases/:caseId/resources/clinical-specialist/:employeeId/done',
  // clinical specialist label
  assignedCsLabel: '/caseservice/cases/:caseId/resources/clinical-specialist/:employeeId/labels',
  // surgeon status
  surgeonDeployedToDonorHospital: '/caseservice/cases/:caseId/resources/surgeon/:employeeId/deployed-to-donor-hospital',
  surgeonAtDonor: '/caseservice/cases/:caseId/resources/surgeon/:employeeId/at-donor',
  surgeonRecoveryCompleted: '/caseservice/cases/:caseId/resources/surgeon/:employeeId/recovery-is-completed',
  surgeonDeployedFromDonorHospital:
    '/caseservice/cases/:caseId/resources/surgeon/:employeeId/deployed-from-donor-hospital',
  surgeonDone: '/caseservice/cases/:caseId/resources/surgeon/:employeeId/done',
  // ocs console status
  consoleDeployed: '/caseservice/cases/:caseId/resources/ocsconsole/:consoleId/deployed',
  consoleDone: '/caseservice/cases/:caseId/resources/ocsconsole/:consoleId/done',
  // access tickets
  accessTickets: '/caseservice/cases/:caseId/access-tickets/archive',
  accessTicketsGrant: '/caseservice/cases/:caseId/access-tickets/archive/grant',
  accessTicketsGrantInfinite: '/caseservice/cases/:caseId/access-tickets/archive/grant-infinite',
  accessTicketsRevoke: '/caseservice/cases/:caseId/access-tickets/archive/revoke/:userId',
  accessTicketsRevokeInfinite: '/caseservice/cases/:caseId/access-tickets/archive/revoke-infinite/:userId',
} as const;

export const getCaseApiUrl = {
  list: () => caseApiPaths.list,
  count: () => caseApiPaths.count,
  duplicatesList: () => caseApiPaths.duplicatesList,
  createDraftCase: () => caseApiPaths.createDraftCase,
  createClinicalScreeningCase: () => caseApiPaths.createClinicalScreeningCase,
  createTxCenterDraftCase: () => caseApiPaths.createTxCenterDraftCase,
  deleteDraftCase: (caseId: string) => replacePathParams(caseApiPaths.deleteDraftCase, { caseId }),
  caseById: (caseId: string) => replacePathParams(caseApiPaths.caseById, { caseId }),
  caseStatus: (caseId: string) => replacePathParams(caseApiPaths.caseStatus, { caseId }),
  caseUpdate: (caseId: string) => replacePathParams(caseApiPaths.caseUpdate, { caseId }),
  updateTxCenterOR: (caseId: string) => replacePathParams(caseApiPaths.updateTxCenterOR, { caseId }),
  caseNotes: (caseId: string) => replacePathParams(caseApiPaths.caseNotes, { caseId }),
  caseNoteById: (caseId: string, noteId: string) => replacePathParams(caseApiPaths.caseNoteById, { caseId, noteId }),
  pinCaseNote: (caseId: string, noteId: string) => replacePathParams(caseApiPaths.pinCaseNote, { caseId, noteId }),
  unpinCaseNote: (caseId: string, noteId: string) => replacePathParams(caseApiPaths.unpinCaseNote, { caseId, noteId }),
  archiveCases: () => caseApiPaths.archiveCases,
  bulkAssignmentCases: () => caseApiPaths.bulkAssignmentCases,
  bulkAssignmentStatus: () => caseApiPaths.bulkAssignmentStatus,
  bulkAssignmentAction: () => caseApiPaths.bulkAssignmentAction,
  reallocationCandidates: () => caseApiPaths.reallocationCandidates,
  caseLogs: (caseId: string) => replacePathParams(caseApiPaths.caseLogs, { caseId }),
  caseActivityLog: (caseId: string) => replacePathParams(caseApiPaths.caseActivityLog, { caseId }),
  getOrganAcceptanceCriteriaTemplate: () => caseApiPaths.getOrganAcceptanceCriteriaTemplate,
  createOrganAcceptanceCriteriaTemplate: () => caseApiPaths.createOrganAcceptanceCriteriaTemplate,
  updateOrganAcceptanceCriteriaTemplate: (templateId: string) =>
    replacePathParams(caseApiPaths.updateOrganAcceptanceCriteriaTemplate, { templateId }),
  statusClinicalScreening: (caseId: string) => replacePathParams(caseApiPaths.statusClinicalScreening, { caseId }),
  statusAccepted: (caseId: string) => replacePathParams(caseApiPaths.statusAccepted, { caseId }),
  statusPendingLogistics: (caseId: string) => replacePathParams(caseApiPaths.statusPendingLogistics, { caseId }),
  statusResourcesBooked: (caseId: string) => replacePathParams(caseApiPaths.statusResourcesBooked, { caseId }),
  statusResourcesDeployed: (caseId: string) => replacePathParams(caseApiPaths.statusResourcesDeployed, { caseId }),
  statusAtDonorHospital: (caseId: string) => replacePathParams(caseApiPaths.statusAtDonorHospital, { caseId }),
  statusOnOcs: (caseId: string) => replacePathParams(caseApiPaths.statusOnOcs, { caseId }),
  statusDeployedToTxCenter: (caseId: string) => replacePathParams(caseApiPaths.statusDeployedToTxCenter, { caseId }),
  statusAtTxCenter: (caseId: string) => replacePathParams(caseApiPaths.statusAtTxCenter, { caseId }),
  statusOffOcs: (caseId: string) => replacePathParams(caseApiPaths.statusOffOcs, { caseId }),
  statusReturningToBase: (caseId: string) => replacePathParams(caseApiPaths.statusReturningToBase, { caseId }),
  statusCaseFinished: (caseId: string) => replacePathParams(caseApiPaths.statusCaseFinished, { caseId }),
  statusCaseClosed: (caseId: string) => replacePathParams(caseApiPaths.statusCaseClosed, { caseId }),
  statusCasesClosed: () => caseApiPaths.statusCasesClosed,
  statusDeclined: (caseId: string) => replacePathParams(caseApiPaths.statusDeclined, { caseId }),
  statusServiceDeclined: (caseId: string) => replacePathParams(caseApiPaths.statusServiceDeclined, { caseId }),
  statusBollbackToServiceDeclined: (caseId: string) =>
    replacePathParams(caseApiPaths.statusRollbackToServiceDeclined, { caseId }),
  statusChange: (caseId: string) => replacePathParams(caseApiPaths.statusChange, { caseId }),
  routePlanningStatus: (caseId: string) => replacePathParams(caseApiPaths.routePlanningStatus, { caseId }),
  waitingAviationApproval: (caseId: string) => replacePathParams(caseApiPaths.waitingAviationApproval, { caseId }),
  waitingForQuoteApproval: (caseId: string) => replacePathParams(caseApiPaths.waitingForQuoteApproval, { caseId }),
  approveAviation: (caseId: string) => replacePathParams(caseApiPaths.approveAviation, { caseId }),
  rejectAviation: (caseId: string) => replacePathParams(caseApiPaths.rejectAviation, { caseId }),
  approveGround: (caseId: string) => replacePathParams(caseApiPaths.approveGround, { caseId }),
  approveQuoteInternally: (caseId: string) => replacePathParams(caseApiPaths.approveQuoteInternally, { caseId }),
  quoteSentToTxReview: (caseId: string) => replacePathParams(caseApiPaths.quoteSentToTxReview, { caseId }),
  bookingPendingStatus: (caseId: string) => replacePathParams(caseApiPaths.bookingPendingStatus, { caseId }),
  resourceBookedRouteStatus: (caseId: string) => replacePathParams(caseApiPaths.resourceBookedRouteStatus, { caseId }),
  routePlanningDoneStatus: (caseId: string) => replacePathParams(caseApiPaths.routePlanningDoneStatus, { caseId }),
  caseOrganAcceptanceCriteria: (caseId: string) =>
    replacePathParams(caseApiPaths.caseOrganAcceptanceCriteria, { caseId }),
  assignUsers: (caseId: string) => replacePathParams(caseApiPaths.assignUsers, { caseId }),
  assignOpoContacts: (caseId: string) => replacePathParams(caseApiPaths.assignOpoContacts, { caseId }),
  approveQuoteByTx: (caseId: string) => replacePathParams(caseApiPaths.approveQuoteByTx, { caseId }),
  rejectQuoteByTx: (caseId: string) => replacePathParams(caseApiPaths.rejectQuoteByTx, { caseId }),
  declineOrgan: (caseId: string) => replacePathParams(caseApiPaths.declineOrgan, { caseId }),
  approveOrgan: (caseId: string) => replacePathParams(caseApiPaths.approveOrgan, { caseId }),
  declineService: (caseId: string) => replacePathParams(caseApiPaths.declineService, { caseId }),
  approveService: (caseId: string) => replacePathParams(caseApiPaths.approveService, { caseId }),
  favorite: (caseId: string) => replacePathParams(caseApiPaths.favorite, { caseId }),
  addLink: (caseId: string) => replacePathParams(caseApiPaths.addLink, { caseId }),
  changeLink: (caseId: string, linkId: string) => replacePathParams(caseApiPaths.changeLink, { caseId, linkId }),
  changeSupplementalOrgan: (caseId: string) => replacePathParams(caseApiPaths.changeSupplementalOrgan, { caseId }),
  wols: (caseId: string) => replacePathParams(caseApiPaths.wols, { caseId }),
  nrpType: (caseId: string) => replacePathParams(caseApiPaths.nrpType, { caseId }),
  copyClinicalData: () => caseApiPaths.copyClinicalData,
  randomizationClinicalData: (caseId: string) => replacePathParams(caseApiPaths.randomizationClinicalData, { caseId }),
  kidneyRandomization: (caseId: string) => replacePathParams(caseApiPaths.kidneyRandomization, { caseId }),
  assignedCsLabel: (caseId: string, employeeId: string) =>
    replacePathParams(caseApiPaths.assignedCsLabel, { caseId, employeeId }),
  csDeployedToDonorHospital: (caseId: string, employeeId: string) =>
    replacePathParams(caseApiPaths.csDeployedToDonorHospital, { caseId, employeeId }),
  csAtDonor: (caseId: string, employeeId: string) => replacePathParams(caseApiPaths.csAtDonor, { caseId, employeeId }),
  csOnOcs: (caseId: string, employeeId: string) => replacePathParams(caseApiPaths.csOnOcs, { caseId, employeeId }),
  csDeployedFromDonorHospital: (caseId: string, employeeId: string) =>
    replacePathParams(caseApiPaths.csDeployedFromDonorHospital, { caseId, employeeId }),
  csAtTxCenter: (caseId: string, employeeId: string) =>
    replacePathParams(caseApiPaths.csAtTxCenter, { caseId, employeeId }),
  csOffOcs: (caseId: string, employeeId: string) => replacePathParams(caseApiPaths.csOffOcs, { caseId, employeeId }),
  csDeployedFromTxCenter: (caseId: string, employeeId: string) =>
    replacePathParams(caseApiPaths.csDeployedFromTxCenter, { caseId, employeeId }),
  csDone: (caseId: string, employeeId: string) => replacePathParams(caseApiPaths.csDone, { caseId, employeeId }),
  surgeonDeployedToDonorHospital: (caseId: string, employeeId: string) =>
    replacePathParams(caseApiPaths.surgeonDeployedToDonorHospital, { caseId, employeeId }),
  surgeonAtDonor: (caseId: string, employeeId: string) =>
    replacePathParams(caseApiPaths.surgeonAtDonor, { caseId, employeeId }),
  surgeonRecoveryCompleted: (caseId: string, employeeId: string) =>
    replacePathParams(caseApiPaths.surgeonRecoveryCompleted, { caseId, employeeId }),
  surgeonDeployedFromDonorHospital: (caseId: string, employeeId: string) =>
    replacePathParams(caseApiPaths.surgeonDeployedFromDonorHospital, { caseId, employeeId }),
  surgeonDone: (caseId: string, employeeId: string) =>
    replacePathParams(caseApiPaths.surgeonDone, { caseId, employeeId }),
  consoleDeployed: (caseId: string, consoleId: string) =>
    replacePathParams(caseApiPaths.consoleDeployed, { caseId, consoleId }),
  consoleDone: (caseId: string, consoleId: string) =>
    replacePathParams(caseApiPaths.consoleDone, { caseId, consoleId }),
  setSirensLightsSupport: (caseId: string) => replacePathParams(caseApiPaths.setSirensLightsSupport, { caseId }),
  setNonStopFlightRequired: (caseId: string) => replacePathParams(caseApiPaths.setNonStopFlightRequired, { caseId }),
  setKidneyTrial: (caseId: string) => replacePathParams(caseApiPaths.setKidneyTrial, { caseId }),
  setQuestionaryEditAllowance: (caseId: string) =>
    replacePathParams(caseApiPaths.setQuestionaryEditAllowance, { caseId }),
  accessTickets: (caseId: string) => replacePathParams(caseApiPaths.accessTickets, { caseId }),
  accessTicketsGrant: (caseId: string) => replacePathParams(caseApiPaths.accessTicketsGrant, { caseId }),
  accessTicketsGrantInfinite: (caseId: string) =>
    replacePathParams(caseApiPaths.accessTicketsGrantInfinite, { caseId }),
  accessTicketsRevoke: (caseId: string, userId: string) =>
    replacePathParams(caseApiPaths.accessTicketsRevoke, { caseId, userId }),
  accessTicketsRevokeInfinite: (caseId: string, userId: string) =>
    replacePathParams(caseApiPaths.accessTicketsRevokeInfinite, { caseId, userId }),
  createReallocationDraft: () => caseApiPaths.createReallocationDraft,
  createReallocationClinicalScreening: () => caseApiPaths.createReallocationClinicalScreening,
  updateReallocated: (caseId: string) => replacePathParams(caseApiPaths.updateReallocated, { caseId }),
};
